import { Link } from 'react-router-dom';
import { useCatalogs } from '@/lib/api/catalogs';
import { Card } from '@/components/ui/Card';
import { buttonClasses } from '@/components/ui/Button';
import { QueryState } from '@/components/QueryState';
import { SkeletonRows } from '@/components/ui/Skeleton';
import { useWorkspacePath } from '@/lib/workspacePath';

export function CatalogsListPage() {
  const { data, isLoading, error } = useCatalogs();
  const ws = useWorkspacePath();

  return (
    <Card
      title="Catalogs"
      description="Product catalogs your agents can be assigned to search."
      actions={
        <Link
          to={ws('catalogs', 'new')}
          data-testid="new-catalog-link"
          className={buttonClasses({ size: 'sm' })}
        >
          New catalog
        </Link>
      }
    >
      <QueryState
        isLoading={isLoading}
        error={error}
        isEmpty={!data || data.length === 0}
        emptyMessage="No catalogs yet. Create one to start adding products."
        loadingLabel="Loading catalogs"
        skeleton={<SkeletonRows rows={4} />}
      >
        <ul className="divide-y divide-gray-100">
          {data?.map((catalog) => (
            <li
              key={catalog.id}
              className="flex items-center justify-between gap-4 py-3"
              data-testid="catalog-list-item"
            >
              <div className="min-w-0">
                <p className="truncate font-medium text-gray-900">{catalog.name}</p>
                <p className="truncate text-xs text-gray-500">{catalog.description}</p>
                <p className="text-xs text-gray-400">{catalog.product_count} products</p>
              </div>
              <Link
                to={ws('catalogs', catalog.slug)}
                data-testid="catalog-edit-link"
                className={buttonClasses({ variant: 'secondary', size: 'sm' })}
              >
                Edit
              </Link>
            </li>
          ))}
        </ul>
      </QueryState>
    </Card>
  );
}
